import React, { FC, useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { audioComponentStyles, audioLoadingStyles, aiCircularProgressStyles } from "../../styles/aiStyles";

interface AudioComponentProps {
    src: string;
    height?: number;
}

const AudioComponent: FC<AudioComponentProps> = ({src, height}) => {
    const [srcUrl, setSrcUrl] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const convertToBlob = async (initialSrcUrl: string) => {
        try {
            setLoading(true);
            const res = await fetch(initialSrcUrl);
            const blob = await res.blob();
            const finalUrl = URL.createObjectURL(blob);
            setSrcUrl(finalUrl);
        } catch (error) {
            console.log('Error while playing audio, using direct URL');
            setSrcUrl(initialSrcUrl);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (src) {
            convertToBlob(src);
        }
    }, [src]);

    if (loading) {
        return (
            <Box sx={audioLoadingStyles}>
                <CircularProgress
                    size={25}
                    sx={aiCircularProgressStyles}
                />
            </Box>
        );
    }

    return (
        <audio controls controlsList="nodownload" style={height ? { height } : undefined}>
            <source src={srcUrl} type="audio/mp4" />
            Your browser does not support the audio element.
        </audio>
    );
};

export default AudioComponent;
